export default "__VITE_ASSET__BQC1Khtn__"